import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import styles from "./Industries.module.css";
import { Droplet, Truck, Factory, Heart, Zap } from "lucide-react";

import servicesbg1 from "../../../Assests/Images/servicesbg1.jpeg";
import servicesbg2 from "../../../Assests/Images/servicesbg2.jpeg";
import servicesbg3 from "../../../Assests/Images/servicesbg3.jpeg";
import servicesbg4 from '../../../Assests/Images/servicesbg4.jpg';
import servicesbg5 from '../../../Assests/Images/servicesbg5.jpeg';
import servicesbg6 from '../../../Assests/Images/servicesbg6.jpg';
import servicesbg7 from '../../../Assests/Images/servicesbg7.jpg';
import servicesbg8 from '../../../Assests/Images/servicesbg8.jpg';
import servicesbg9 from '../../../Assests/Images/servicesbg9.jpg';


import indus1 from "../../../Assests/icons/indus1.svg";
import indus2 from "../../../Assests/icons/indus2.svg";
import indus3 from "../../../Assests/icons/indus3.svg";
import indus4 from '../../../Assests/icons/indus4.svg';
import indus5 from '../../../Assests/icons/indus5.svg';
import indus6 from '../../../Assests/icons/indus6.svg';
import indus7 from '../../../Assests/icons/indus7.svg';
import indus8 from '../../../Assests/icons/indus8.svg';
import indus9 from '../../../Assests/icons/indus9.svg';


import arrowleft from "../../../Assests/icons/leftArrow.svg";
import arrowright from "../../../Assests/icons/rightArrow.svg";

const industries = [
  {
    title: "Oil & Gas",
    description: "Cost-effective sourcing and logistics support for high-value energy operations.",
    icon: indus1,
    image: servicesbg1,
  },
  {
    title: "Mining",
    description: "Reliable supply chains built for harsh conditions and remote mining environments.",
    icon: indus2,
    image: servicesbg2,
  },
  {
    title: "Manufacturing & Industrial Plants",
    description: "Scalable sourcing for uninterrupted production and smooth operational continuity.",
    icon: indus3,
    image: servicesbg3,
  },
  {
    title: "International Aid & Humanitarian Relief",
    description: "Fast, compliant delivery of essential supplies for humanitarian missions.",
    icon: indus4,
    image: servicesbg4,
  },
  {
    title: "Utility & Energy",
    description: "Trusted procurement for power, water, and renewable energy infrastructure.",
    icon: indus5,
    image: servicesbg5,
  },
  {
    title: "Pharmaceuticals",
    description: "Compliant sourcing for cleanroom, lab, and pharmaceutical production environments.",
    icon: indus6,
    image: servicesbg6,
  },
  {
    title: "Marine & Offshore",
    description: "Durable systems and safety gear for vessels and offshore platforms.",
    icon: indus7,
    image: servicesbg7,
  },
  {
    title: "Healthcare",
    description: "End-to-end procurement for hospitals, clinics, and healthcare responders.",
    icon: indus8,
    image: servicesbg8,
  },
  {
    title: "Petroleum (Refining & Retail)",
    description: "Mission-critical supply for downstream petroleum operations and fuel networks.",
    icon: indus9,
    image: servicesbg9,
  },
];



const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 3000, min: 2000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 2000, min: 1100 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1100, min: 840 },
      items:4,
    },
    mobile: {
      breakpoint: { max: 840, min: 500 },
      items: 2,
    },
    small: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
    },
  };
  
  
  const arrowStyle = {
    background: "transparent",
    border: 0,
    color: "#000000",
    fontSize: "80px"
  };
  const CustomRight = ({ onClick }) => (
    <button className={styles.arrowright} onClick={onClick} style={arrowStyle}>
      <img src={arrowright} alt="next" style={{ width: 18 }} />
    </button>
  );
  
  const CustomLeft = ({ onClick }) => (
    <button className={styles.arrowleft} onClick={onClick} style={arrowStyle}>
      <img src={arrowleft} alt="previous" style={{ width: 18 }} />
    </button>
  );

export function Industries() {
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.heading}>Industries We Serve</h2>
        <p className={styles.subheading}>
          Expert Procurement Services for Critical Global Industries
        </p>
      </div>

      <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        infinite={true}
        keyBoardControl={true}
        arrows
        partialVisible={false}
        className={styles.curoselList}
        itemClass={styles.carouselItem}
        customRightArrow={<CustomRight />}
        customLeftArrow={<CustomLeft />}
      >
        {industries.map((industry, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.imageWrapper}>
              <img src={industry.image} alt={industry.title} className={styles.image} />
              <div className={styles.overlay}></div>
            </div>
            <div className={styles.content}>
              <div className={styles.iconWrapper}>
                <img src={industry.icon} alt="" />
              </div>
              <h3 className={styles.title}>{industry.title}</h3>
              <p className={styles.description}>{industry.description}</p>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
}
